import {
  GetLatestProductMasterBatchJobStatusResponse,
  ProductMasterBatchJobStatusEnum,
} from '@ulysses-inc/harami_api_client'
import { useSnackbar } from 'src/components/snackbar/useSnackbar'
import { useQueryMasterLatestBatchJobStatus } from 'src/features/masters/MasterDetail/api/useQueryMasterLatestBatchJobStatus'
import { BatchJobData } from 'src/features/masters/components/LatestBatchJobStatusDrawer/components/type'
import { isHTTPError } from 'src/state/middleware/saga/handleHttpError'

export const useMasterLatestBatchJobStatusDrawer = (
  masterUuid: string,
  open: boolean,
) => {
  const { showErrorSnackbar } = useSnackbar()
  const { data, isLoading, isFetching, error } =
    useQueryMasterLatestBatchJobStatus(masterUuid, showErrorSnackbar, open)

  const isNotFound = isHTTPError(error) && error.status === 404

  return {
    data: convertToBatchJobData(data),
    isLoading: isLoading || isFetching,
    isNotFound,
  }
}

const convertToBatchJobData = (
  data?: GetLatestProductMasterBatchJobStatusResponse | null,
): BatchJobData | null => {
  if (!data) return null

  if (data.status === ProductMasterBatchJobStatusEnum.Error) {
    return { ...data, errorMessage: data.errorMessage ?? '' }
  }

  return {
    ...data,
    status: data.status as Exclude<
      ProductMasterBatchJobStatusEnum,
      ProductMasterBatchJobStatusEnum.Error
    >,
  }
}
